import * as React from 'react';
import {ErrorResponse, User} from "../api/dtos/dtos";
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from "../app/ApplicationContext";
import locales from "../locales";
import {Select} from "antd";
import furoApi from "../api/FuroApi";
import {SelectValue} from "antd/lib/select";

interface UserSelectorProps {
  disabled?: boolean;
  user?: string;
  onSelect: (userName?: string) => void;
}

interface UserSelectorState {
  salesUsers: User[];
  selectedUserName?: string;
  error?: ErrorResponse;
}

class SalesUserSelector extends React.Component<UserSelectorProps, UserSelectorState> {
  public readonly loadingHandler?: LoadingOverlayHandler;

  constructor(props: UserSelectorProps) {
    super(props);
    this.state = {
      salesUsers: [],
      selectedUserName: props.user,
    };
  }

  public componentDidMount() {
    this.loadSalesUsers();
  }

  public componentDidUpdate(prevProps: Readonly<UserSelectorProps>, prevState: Readonly<UserSelectorState>, snapshot?: any) {
    if (prevProps.user !== this.props.user) {
      this.setState({
        selectedUserName: this.props.user,
      }, () => {
        this.props.onSelect(this.props.user);
      });
    }
  }

  public render(): React.ReactNode {
    const {disabled} = this.props;
    const {salesUsers, selectedUserName} = this.state;
    const fieldDisabled = disabled || salesUsers.length < 2;

    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <Select
          showSearch={true}
          allowClear={false}
          placeholder={locales.choose}
          className="mild-disabled"
          disabled={fieldDisabled}
          value={selectedUserName}
          onChange={this.onValueChange}
        >
          {salesUsers && salesUsers.map(this.renderUser)}
        </Select>
      </>
    );
  }

  private onValueChange = (value: SelectValue) => {
    const userName = String(value);
    this.setState({
      selectedUserName: userName,
    });
    this.props.onSelect(userName);
  };

  private loadSalesUsers = () => {
    const promise = furoApi.users.getSalesUsers()
      .then(this.onSalesUsers)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  }

  private onSalesUsers = (users: User[]) => {
    const selectedUserName = this.state.selectedUserName;

    const selected = users.length === 1 ? users[0].userName : selectedUserName;
    this.setState({
      salesUsers: users,
      selectedUserName: selected,
    });
    this.props.onSelect(selected);
  }

  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  }

  private renderUser = (u: User): React.ReactNode => {
    return (
      <Select.Option
        key={u.userName}
        value={u.userName}
        title={u.userName}
      >
        {u.userName}
      </Select.Option>
    )
  }
}

export default SalesUserSelector;


// WEBPACK FOOTER //
// ./src/event-details/SalesUserSelector.tsx